import { FC } from "react";
import { RatingBox, RatingItem, TextBox } from "./RatingBtn.styled";
import SVG from "react-inlinesvg";
import { heart, star_rating } from "../../../assets/icon";
import { Mobile } from "../../Container/Mobile";
import { Desktop } from "../../Container/Desktop";
import { useTranslation } from "../../../hooks/useTranslation";


const icons: { [key: number]: string } = {
  1: star_rating,
  2: heart,
};
export interface RatingDataInfo {
  value?: number;
}

type Props = {
  value: RatingDataInfo;
  onChange: (value: RatingDataInfo) => void;
  format: number;
  quantity: number;
};

export const RatingBtn: FC<Props> = ({ value, onChange, format, quantity }) => {
  const { t } = useTranslation();

  const items = [...Array(quantity)];
  return (
    <>
      <RatingBox>
        {items.map((_, index) => (
          <RatingItem
            className={index < (value.value ?? 0) ? "active" : ""}
            key={index}
            onClick={() => onChange({value: index + 1})}
          >
            <Mobile>
              <SVG src={icons[format]} width={22} height={23} />
            </Mobile>
            <Desktop>
              <SVG src={icons[format]} width={30} height={30} />
            </Desktop>
          </RatingItem>
        ))}
      </RatingBox>
      <TextBox>
        <span>{t("badlyRating")}</span>
        <span>{t("fineRating")}</span>
        <span>{t("greatRating")}</span>
      </TextBox>
    </>
  );
};
